import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SendHorizontal, Loader2 } from "lucide-react";
import { useState } from "react";
import { useLanguage } from "@/i18n";

export const TransferModal = ({ 
  open, 
  onOpenChange, 
  credits,
  isUnlimitedCredits,
  onTransfer
}) => {
  const { t } = useLanguage();
  const [transferEmail, setTransferEmail] = useState("");
  const [transferAmount, setTransferAmount] = useState(100);
  const [isTransferring, setIsTransferring] = useState(false);

  const handleTransfer = async () => {
    setIsTransferring(true);
    const success = await onTransfer(transferEmail, transferAmount);
    setIsTransferring(false);
    if (success) {
      setTransferEmail("");
      setTransferAmount(100);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-zinc-900 border-zinc-800 max-w-md">
        <DialogHeader>
          <DialogTitle className="text-white flex items-center gap-2">
            <SendHorizontal size={20} /> {t('transfer_credits')}
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
            <p className="text-blue-300 text-sm">
              {isUnlimitedCredits 
                ? t('credits')
                : `${t('credits')}: ${credits}`
              }
            </p>
          </div>
          
          <div>
            <label className="text-sm text-zinc-400 mb-2 block">{t('email')}</label>
            <Input 
              type="email"
              placeholder={t('email')}
              value={transferEmail}
              onChange={(e) => setTransferEmail(e.target.value)}
              className="bg-zinc-800 border-zinc-700"
              data-testid="transfer-email-input"
            />
          </div>
          
          <div>
            <label className="text-sm text-zinc-400 mb-2 block">{t('credits')}</label>
            <Input 
              type="number"
              placeholder="100"
              value={transferAmount}
              onChange={(e) => setTransferAmount(parseInt(e.target.value) || 0)}
              className="bg-zinc-800 border-zinc-700"
              min={1}
              data-testid="transfer-amount-input"
            />
          </div>
          
          <Button 
            onClick={handleTransfer}
            disabled={isTransferring || !transferEmail || transferAmount <= 0}
            className="w-full bg-green-600 hover:bg-green-700"
            data-testid="transfer-credits-btn"
          >
            {isTransferring ? (
              <><Loader2 className="animate-spin mr-2" size={16} /> {t('loading')}</>
            ) : (
              <><SendHorizontal size={16} className="mr-2" /> {t('transfer_credits')}</>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
